// this file is generated by update_shopify_store_data.py at 2026-11-03 20:18:45.400270
var courses = [
    {
        "course_id": "4809F33E-28BB-F011-99A0-005056A78EAA",
        "course_version": 1,
        "name": "From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
        "course_type": 1,
        "author_information": "Annie Youngblood, NBC-HWC",
        "description": "This course focuses on what happens after the conversation about health-related behavior change has begun\u2014how to clarify values, set realistic goals, and move forward even when confidence is low. You\u2019ll explore strategies for goal-setting, confidence scaling, and real-time support in brief encounters. The course also highlights prevention, whole-person care, and the impact of social determinants of health. Through applied case studies, you\u2019ll learn practical, evidence-based approaches for guiding change in everyday clinical realities.",
        "learning_objectives_html": "By the end of this course, leaners will be able to:\r\n<ol>Analyze key theories and principles of health behavior change and their application to clinical and community practice.\r\n</ol>\r\n<ol>Demonstrate values-driven, person-centered strategies to explore motivation, clarify goals, and address ambivalence.\r\n</ol>\r\n<ol>Differentiate between behavioral and outcome goals to support the development of realistic, actionable next steps.\r\n</ol>\r\n<ol>Apply communication techniques&mdash;including powerful questioning, summarizing, confidence scaling, and brief interventions&mdash;to guide real-time conversations.\r\n</ol>\r\n<ol>Integrate prevention, whole-person care, and social determinants of health into behavior change discussions that promote long-term well-being.\r\n</ol>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE68B22F-F6D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing: From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AE7EFAF2-F7D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - From Ambivalence to Action: Goal-Setting, Confidence, and Prevention in Practice",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "222C7486-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Interpersonal Relationships",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 4.5 contact hours to participants who complete all sections and pass the assessment with a score of 80% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];